import React from "react";
import { RiyalSymbol } from "../components/RiyalSymbol/RiyalSymbol";

export const displayPrice = (price) => {
  // Agar price undefined ya null ho to empty return karein
  // Note: Maine `price !== 0` add kiya hai taake agar price 0 ho to wo gayab na ho, balkay 0.00 show ho.
  if (!price && price !== 0) return "";

  if (typeof price !== "number") {
    return (
      <span className="text__rtl">
        {`${price} `}
        <RiyalSymbol size={10} />
      </span>
    );
  }

  return (
    <span className="text__rtl">
      {/* Updated: Added comma separation and fixed 2 decimals */}
      {`${price.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} `}
      <RiyalSymbol size={10} />
    </span>
  );
};
